var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "modal-body" }, [
      _c(
        "form",
        { staticClass: "m-form m-form--state", attrs: { action: "" } },
        [
          _c("div", { staticClass: "m-portlet__body" }, [
            _c("div", { staticClass: "form-group m-form__group" }, [
              _c(
                "div",
                {
                  class: [{ "has-danger": _vm.errors.has("name") }, "col-lg-12"]
                },
                [
                  _c("label", { attrs: { for: "name" } }, [
                    _vm._v(
                      _vm._s(_vm._f("capitalize")(_vm._f("translate")("name")))
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.site.name,
                        expression: "site.name"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:2|max:70",
                        expression: "'required|min:2|max:70'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "text",
                      id: "name",
                      name: "name",
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_name")
                      )
                    },
                    domProps: { value: _vm.site.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.site, "name", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("name"),
                          expression: "errors.has('name')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("name")) + " ")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-form__group" }, [
              _c(
                "div",
                {
                  class: [
                    { "has-danger": _vm.errors.has("email") },
                    "col-lg-12"
                  ]
                },
                [
                  _c("label", { attrs: { for: "email" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(
                          _vm._f("translate")("manager_email")
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.site.email,
                        expression: "site.email"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email",
                        expression: "'required|email'"
                      }
                    ],
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "text",
                      id: "email",
                      name: "email",
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_email")
                      )
                    },
                    domProps: { value: _vm.site.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.site, "email", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("email"),
                          expression: "errors.has('email')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("email")) + " ")]
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            id: "btn-cancel-site"
          },
          on: { click: _vm.resetForm }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("cancel"))) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button" },
          on: { click: _vm.submitForm }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("submit"))) +
              "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fa70ca5", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fa70ca5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/sites/New.vue
// module id = 547
// module chunks = 0 1 73 186